/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import { Company } from 'types/entities/Company'
import CompanyAutocompleteItem from './CompanyAutocompleteItem'

interface CompanyAutocompleteItemsListProps {
    companies: Company[]
    selectedOptionRef: React.RefObject<HTMLLIElement>
}

const CompanyAutocompleteItemsList = (
    props: CompanyAutocompleteItemsListProps
) => {
    if (!props.companies.length) {
        return null
    }

    return (
        <>
            {props.companies.map((company) => (
                <CompanyAutocompleteItem
                    key={company.id}
                    company={company}
                    selectedOptionRef={props.selectedOptionRef}
                />
            ))}
        </>
    )
}

export default CompanyAutocompleteItemsList
